<template>
  <div class="container o-form-page">
    <b-container fluid="xs" v-if="item.code" class="container-fixed container">
      <b-row>
        <b-col>
          <h1>{{ item.code }}</h1>
        </b-col>
      </b-row>
    </b-container>
    <o-working-overlay :working="working"></o-working-overlay>
    <o-section :title="title" @click="enableDebug($event)" :level="0">
      <item-form-request
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
        v-bind:create="create"
        @reload="reload"
      ></item-form-request>
    </o-section>

    <o-action-buttons
      :hide-save="getItemId"
      hide-delete
      :item="item"
      :form-state="formState"
      :create="create"
      @save="checkFiles(doSave)"
      @saveAndClose="checkFiles(doSaveAndClose)"
      @saveAndNew="checkFiles(doSaveAndNew)"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    >
    </o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
  CreateCodeTableFetchMixin,
} from "../../../vue-ocom/mixins";
import ItemFormRequest from "../components/ItemForm.vue";
import OActionButtons from "../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";
import { mapMutations, mapActions } from "vuex";
import { composeData } from "../../../lib/common/composeData";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("ServiceExtra", "service_extra_submission"),
    CreateGroupPermissionMixin("ServiceExtra"),
    CreateCodeTableFetchMixin(["Process"], {
      model_type: "service_extra",
      filter: "active",
      sort: "created_date",
      order: "desc",
    }),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemFormRequest,
  },
  data() {
    return {
      hideCode: true,
    };
  },
  props: {
    create: { type: Boolean, default: false },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapMutations(["showMessage"]),
    ...mapActions("WorkflowInstanceModule", {
      saveWorkFLow: "saveItem",
    }),
    onBeforeSave() {
      // push 1 for subcontractor cost
      /**
       * repair_material = 52
       * cost_per_item = quoted_amount *  0.15;
       */
      const subcon_cost_data = {
        repair_material: 52,
        cost_per_item: this.item.quoted_amount * 0.15,
      };
      const admin_cost_data = {
        repair_material: 53,
        cost_per_item: this.item.quoted_amount,
      };

      const subcon_cost = composeData(subcon_cost_data);
      const admin_cost = composeData(admin_cost_data);

      this.item.used_materials.push(admin_cost);
      this.item.used_materials.push(subcon_cost);
    },
    checkFiles(functSave) {
      if (this.item.repair_files.length < 2) {
        this.showMessage({
          message: "Please upload atleast two (2) photos",
          type: "danger",
          show: true,
        });
        return false;
      }
      if (this.item.category_of_works.length <= 0) {
        this.showMessage({
          message: "Please select category of works",
          type: "danger",
          show: true,
        });
        return false;
      }

      if (this.item.quoted_amount <= 0) {
        this.showMessage({
          message: "Please enter a valid quoted amount",
          type: "danger",
          show: true,
        });
        return false;
      }

      // let data = new FormData();
      // data.append(_new, true);
      // data.append(process, this.getLatestProcess);
      const data = {
        _new: true,
        process: this.getLatestProcess,
      };
      this.saveWorkFLow(data).then((result) => {
        this.item.workflow_instance = result.id;
        // this.onBeforeSave();
        functSave();
      });
      // create workflow_instance
      // set the wf_instance.process is the latest process
      // then hit save submission
    },
    handleScroll(event) {
      if (window.scrollY <= 10) {
        this.hideCode = false;
      } else {
        this.hideCode = true;
      }
    },
  },
  computed: {
    getItemId() {
      if (this.item.id) {
        return true;
      }

      return false;
    },
    getLatestProcess() {
      if (this.optionProcessItems.length > 0) {
        return this.optionProcessItems[0].id;
      }
      return null;
    },
    title() {
      if (this.create) {
        return "Create Extra Submission";
      }

      return "Edit Extra Submission";
    },
  },
};
</script>
<style scoped>
.container-fixed {
  background: #3071a9;
  color: #fff;
  border: 1px #3071a9 solid;
  position: sticky;
  top: 50px;
  z-index: 1000;
  margin-top: -10px;
}
.container-fixed p {
  margin: 0;
  line-break: anywhere;
}
</style>
